import { DictType } from "@pma/types"
import { create } from "zustand"

interface useGisTasksStore {
  gisTasks: DictType[]
  setGisTasks: (gisTasks: DictType[] | undefined) => void
}

interface userCustomColumnsStore {
  customColumns: DictType[]
  setCustomColumns: (customColumns: DictType[] | undefined) => void
}

interface useWorkDiaryStore {
  workDiaryDialog: boolean
  workDiaryStatusList: DictType[]
  contractorCompanyList: DictType[]
  workWeatherList: DictType[]
  workDiaryStructuresList: DictType[]
  workDiaryWorkForceList: DictType[]
  workDiaryToolsList: DictType[]
  setWorkDiaryDialog: (workDiaryDialog: boolean) => void
  setWorkDiaryStatusList: (workDiaryStatusList: DictType[]) => void
  setContractorCompanyList: (contractorCompanyList: DictType[]) => void
  setWorkWeatherList: (workWeatherList: DictType[]) => void
  setWorkDiaryStructuresList: (workDiaryStructuresList: DictType[]) => void
  setWorkDiaryWorkForceList: (workDiaryWorkForceList: DictType[]) => void
  setWorkDiaryToolsList: (workDiaryToolsList: DictType[]) => void
}

export const useGisTasks = create<useGisTasksStore>((set) => ({
  gisTasks: [],
  setGisTasks: (gisTasks: DictType[] | undefined) => {
    set({ gisTasks })
  },
}))

export const useCustomColumns = create<userCustomColumnsStore>((set) => ({
  customColumns: [],
  setCustomColumns: (customColumns: DictType[] | undefined) => {
    set({ customColumns })
  },
}))

export const useWorkDiary = create<useWorkDiaryStore>((set) => ({
  workDiaryDialog: false,
  workDiaryStatusList: [],
  contractorCompanyList: [],
  workWeatherList: [],
  workDiaryStructuresList: [],
  workDiaryWorkForceList: [],
  workDiaryToolsList: [],
  setWorkDiaryDialog: (workDiaryDialog: boolean) => {
    set({ workDiaryDialog })
  },
  setWorkDiaryStatusList: (workDiaryStatusList: DictType[]) => {
    set({ workDiaryStatusList })
  },
  setContractorCompanyList: (contractorCompanyList: DictType[]) => {
    set({ contractorCompanyList })
  },
  setWorkWeatherList: (workWeatherList: DictType[]) => {
    set({ workWeatherList })
  },
  setWorkDiaryStructuresList: (workDiaryStructuresList: DictType[]) => {
    set({ workDiaryStructuresList })
  },
  setWorkDiaryWorkForceList: (workDiaryWorkForceList: DictType[]) => {
    set({ workDiaryWorkForceList })
  },
  setWorkDiaryToolsList: (workDiaryToolsList: DictType[]) => {
    set({ workDiaryToolsList })
  }
}))
